import { c as _c } from "react/compiler-runtime";
import { Form, Formik } from 'formik';
import { useContext, useEffect, useState } from 'react';
import { APISource } from '../../../../../../../../typings/Source.interface';
import { cleanseFormErrorObject } from '../../../../../utils/form';
import Button from '../../../../common/base/Button';
import { Div } from '../../../../common/helpers/StyledUtils';
import { useToasts } from '../../../../common/Toast';
import { GlobalContext } from '../../../../contexts/GlobalContext';
import resource_details_form_props from '../../Connections/Forms/resource_details';
import configuration_form_props, { SourceConfigurationFormValues } from '../../Connections/Forms/source_configuration';
import { DashboardContext } from '../../DashboardContext';
import { CLIOnboardingContext } from '../GuidedCLIOnboarding';
interface Props {
  context: CLIOnboardingContext;
  mutateContext: (input: {
    source?: APISource;
  }) => void;
  nextStep: () => void;
  is_current_step: boolean;
}
const DefineWebhookSource: React.FC<Props> = t0 => {
  const $ = _c(31);
  const {
    context: t1,
    mutateContext,
    nextStep
  } = t0;
  const {
    source
  } = t1;
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const {
    source_types
  } = useContext(DashboardContext);
  const {
    addToast
  } = useToasts();
  const [render_key, setRenderKey] = useState(1);
  let t2;
  if ($[0] !== source) {
    t2 = () => {
      if (source) {
        setRenderKey(_temp);
      }
    };
    $[0] = source;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = source?.config.allowed_http_methods;
  const t4 = source?.config.auth;
  let t5;
  if ($[2] !== t3 || $[3] !== t4) {
    t5 = [t3, t4];
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  useEffect(t2, t5);
  let t6;
  if ($[5] !== source) {
    t6 = resource_details_form_props.getInitialValues(source || undefined);
    $[5] = source;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== source) {
    t7 = configuration_form_props.getInitialValues(source || undefined);
    $[7] = source;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t6 || $[10] !== t7) {
    t8 = {
      ...t6,
      ...t7
    };
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== HookdeckAPI.sources || $[13] !== source || $[14] !== source_types) {
    t9 = async values => cleanseFormErrorObject({
      ...(await resource_details_form_props.validate(values, name => source && name === source.name ? Promise.resolve(false) : HookdeckAPI.sources.nameIsUsed(name), true)),
      ...(await configuration_form_props.validate(values as SourceConfigurationFormValues, source_types))
    });
    $[12] = HookdeckAPI.sources;
    $[13] = source;
    $[14] = source_types;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== HookdeckAPI.sources || $[17] !== addToast || $[18] !== mutateContext || $[19] !== nextStep || $[20] !== source || $[21] !== source_types) {
    t10 = (v, t11) => {
      const {
        resetForm
      } = t11;
      const values_0 = {
        ...resource_details_form_props.postprocessValues(v),
        ...configuration_form_props.postprocessValues(v as SourceConfigurationFormValues, source_types)
      };
      const promise = source ? HookdeckAPI.sources.update(source.id, values_0) : HookdeckAPI.sources.create(values_0);
      return promise.then(new_source => {
        mutateContext({
          source: new_source
        });
        resetForm({
          values: {
            ...v,
            ...resource_details_form_props.getInitialValues(new_source || undefined),
            ...configuration_form_props.getInitialValues(new_source || undefined),
            show_advanced: v.show_advanced
          }
        });
        if (source) {
          addToast("success", `Source ${new_source.name} configuration updated`);
        }
        nextStep();
      }).catch(e => {
        addToast("error", `An error occurred while saving the source${e.response?.data[0] ? `: ${e.response.data[0]}` : ""}`);
      });
    };
    $[16] = HookdeckAPI.sources;
    $[17] = addToast;
    $[18] = mutateContext;
    $[19] = nextStep;
    $[20] = source;
    $[21] = source_types;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== source) {
    t11 = t12 => {
      const {
        isValid,
        isSubmitting,
        handleSubmit,
        dirty
      } = t12;
      return <Form data-testid="guided-cli-define-source-form" onSubmit={handleSubmit}><Div m={{
          t: 0
        }}><configuration_form_props.Fields prefix="" hide_optional_features={true} in_guided_connection={true} /></Div><Div flex={{
          gap: 3
        }} m={{
          t: 6
        }}><Button submit={true} disabled={!isValid || isSubmitting || !!source && !dirty} primary={!source} outline={!!source} icon={isSubmitting ? "loading" : undefined}>{source ? "Update" : "Save"}</Button></Div></Form>;
    };
    $[23] = source;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== render_key || $[26] !== t10 || $[27] !== t11 || $[28] !== t8 || $[29] !== t9) {
    t12 = <Formik key={render_key} initialValues={t8} validateOnMount={true} validate={t9} onSubmit={t10}>{t11}</Formik>;
    $[25] = render_key;
    $[26] = t10;
    $[27] = t11;
    $[28] = t8;
    $[29] = t9;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  return t12;
};
export default DefineWebhookSource;
function _temp(prev) {
  return prev + 1;
}